export const Spacer = ({ width, height, className }: { width?: number | string; height?: number | string; className?: string }) => <div style={{ width, height }} className={className || ""}></div>;
